/**
 * Component Registry for Pillar Properties Theme
 * 
 * Extends the base landing-page theme registry with Pillar Properties specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-landing-page/registry';

import { Footer } from './components/Footer';

/**
 * Pillar Properties specific component overrides.
 * These components have been customized for the Pillar Properties brand.
 */
const pillarpropertiesOverrides: Partial<ComponentRegistry> = {
  Footer,
};

/**
 * Final merged registry for Pillar Properties properties.
 * Inherits all components from the landing-page theme, with Pillar Properties overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...pillarpropertiesOverrides,
};

export default registry;
